import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-empty-contact-info-stub',
  templateUrl: './empty-contact-info-stub.component.html',
  styleUrls: ['./empty-contact-info-stub.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyContactInfoStubComponent {
}
